var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      ref: "cta",
      staticClass: "message-bar__cta",
      attrs: { "data-element-id": "X_X_MainNav_Services" },
      on: { click: _vm.emitClick },
    },
    [
      _c(
        "div",
        {
          staticClass: "message-bar__title",
          class: { "message-bar__title--bold": _vm.isClicked },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_vm.translation("header.message_bar_title")) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isMobile
        ? _c("rb-lazy-icon", {
            attrs: { icon: "caret-big-right", text: "caret-big-right" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }